import { ref, computed } from '@vue/composition-api'
import store from '@/store'
import { apiToastWarning } from '@/@core/utils/toast'
import { checkListTitle, tooltipData } from '@/constants'

function baseItems(data, tooltip, isRetailer) {
  return [
    {
      title: checkListTitle.general,
      hovermsg: tooltip.general,
      visible: data.general,
      link: 'profile',
      nextData: data.segmentation,
      tabIndex: 0,
    },
    {
      title: checkListTitle.segmentation,
      hovermsg: tooltip.segmentation,
      visible: data.segmentation,
      link: 'profile',
      nextData: data.documents,
      tabIndex: 2,
    },
    {
      title: checkListTitle.documents,
      hovermsg: tooltip.documents,
      visible: data.documents,
      link: 'profile',
      nextData: data.address,
      tabIndex: 3,
    },
    {
      title: checkListTitle.addresses,
      hovermsg: tooltip.addresses,
      visible: data.address,
      link: 'profile',
      nextData: isRetailer ? data.firstOrder : data.firstCollection,
      tabIndex: 4,
    },
  ]
}

function firstCollectionItem(data) {
  return {
    title: checkListTitle.firstCollection,
    hovermsg: tooltipData.brand.firstCollection,
    visible: data.firstCollection,
    link: 'collection/edit',
    nextData: data.firstOrder,
  }
}

function firstOrderItem(data, tooltip, isRetailer) {
  return {
    title: isRetailer ? checkListTitle.retailerFirstOrder : checkListTitle.brandFirstOrder,
    hovermsg: tooltip.firstorder,
    visible: data.firstOrder,
    link: isRetailer ? 'explore' : 'orders',
    nextData: data.teammates,
  }
}

function teammatesItem(data) {
  return {
    title: checkListTitle.teammates,
    hovermsg: tooltipData.retailer.teammates,
    visible: data.teammates,
    link: 'profile',
    nextData: data.referrals,
    tabIndex: 5,
  }
}

function normalizeVisible(item) {
  return { ...item, visible: item.visible || false }
}

function buildChecklistItems(data, isRetailer) {
  const tooltip = isRetailer ? tooltipData.retailer : tooltipData.brand
  const items = baseItems(data, tooltip, isRetailer)
  if (!isRetailer) items.push(firstCollectionItem(data))
  items.push(firstOrderItem(data, tooltip, isRetailer))
  items.push(teammatesItem(data))
  return items.map(normalizeVisible)
}

export function useOnboardingChecklist({ kpRequest, kpEndpoint } = {}) {
  const checkList = ref(null)
  const checkListData = ref(null)
  const percentage = ref(0)
  const isLoaded = ref(false)
  const isRetailer = computed(() => store.getters.isRetailer)

  async function fetchChecklist() {
    try {
      const res = await kpRequest({ ...kpEndpoint.profile.onBoardCheckList })
      checkListData.value = res?.data?.data
      assignData()
    } catch (_) {
      apiToastWarning('Checklist is not fetched')
    } finally {
      isLoaded.value = true
    }
  }

  function assignData() {
    const data = checkListData.value
    if (!data) return
    percentage.value = data.percentage || 0
    checkList.value = buildChecklistItems(data, isRetailer.value)
  }

  return {
    checkList,
    percentage,
    isLoaded,
    fetchChecklist,
  }
}
